import type { ReactNode } from 'react';
import { View } from 'react-native';
import { falHeart } from 'shared/@generated/icons/falHeart';
import { falPaw } from 'shared/@generated/icons/falPaw';
import { BreedAdvisorMatch } from 'shared/components/breed-advisor-match';
import { Icon } from 'shared/components/icon';
import { Text } from 'shared/components/text';
import type { AdvisorCard, AdvisorTranslate } from 'shared/library/breed-advisor';

export function BreedAdvisorResultGroup({
  cards,
  title,
  favorite = false,
  copy,
  renderCard,
}: {
  cards: AdvisorCard[];
  title: string;
  favorite?: boolean;
  copy: AdvisorTranslate;
  renderCard?: (card: AdvisorCard) => ReactNode;
}) {
  if (!cards.length) return null;

  return (
    <View
      testID={`advisor-result-group-${favorite ? 'favorites' : 'matches'}`}
      className="border-brand-brown-dark/15 shadow-brand-brown-dark/5 overflow-hidden rounded border bg-white shadow-sm"
    >
      <View className="min-h-11 flex-row items-center gap-2.5 px-4 py-3">
        <Icon
          icon={favorite ? falHeart : falPaw}
          className="text-brand-brown-dark size-4 shrink-0"
        />
        <Text
          accessibilityRole="header"
          aria-level={2}
          className="text-brand-brown-dark min-w-0 flex-1 text-sm font-semibold md:text-base"
        >
          {title}
        </Text>
      </View>
      {cards.map((card) => (
        <View key={card.breed.id} className="border-brand-brown-dark/10 border-t">
          {renderCard ? renderCard(card) : <BreedAdvisorMatch card={card} copy={copy} />}
        </View>
      ))}
    </View>
  );
}
